/**
 * The volume to set a sound xyz edition to if it is an open edition,
 * used specifically by the track publisher modal when publishing
 * a track to the sound xyz protocol
 */
export const SOUND_XYZ_OPEN_EDITION_VOLUME = 2147483647 // INT MAX

export const SOUND_XYZ_GOERLI_OPEN_METADATA_MODULE = '0xb3D6EFD8a463193ae15676330CD5c39008115C7A'
export const SOUND_XYZ_MAINNET_OPEN_METADATA_MODULE = '0xE311e941D49DBf1747E8531209f4d3F4c49F5eA0'

/**
 * These were given to us directly by Vignesh from sound team. These give a small fee (2.5%?) to Sound.xyz.
 * They require we use these for our mainnet deploys in order for them to be shown on their site.
 */
export const SOUND_XYZ_MAINNET_RANGE_MINTER_WITH_FEE = '0x65c25fadd9b88df5c8c101a3b99a5d614b708596'
export const SOUND_XYZ_MAINNET_MERKLE_MINTER_WITH_FEE = '0xeae422887230c0ffb91fd8f708f5fdd354c92f2f'

export const SOUND_XYZ_GENRES = {
  ALTERNATIVE_ROCK: 'Alternative Rock',
  AMBIENT: 'Ambient',
  BOUNCE: 'Bounce',
  CLASSICAL: 'Classical',
  COUNTRY: 'Country',
  DANCE_EDM: 'Dance & EDM',
  DANCEHALL: 'Dancehall',
  DEEP_HOUSE: 'Deep House',
  DISCO: 'Disco',
  DOWNTEMPO: 'Downtempo',
  DRUM_BASS: 'Drum & Bass',
  DUBSTEP: 'Dubstep',
  ELECTRONIC: 'Electronic',
  EXPERIMENTAL: 'Experimental',
  FOLK_SINGER_SONGWRITER: 'Folk & Singer-Songwriter',
  HIP_HOP_RAP: 'Hip-hop & Rap',
  HOUSE: 'House',
  INDIE: 'Indie',
  JAZZ_BLUES: 'Jazz & Blues',
  LATIN: 'Latin',
  METAL: 'Metal',
  PIANO: 'Piano',
  POP: 'Pop',
  R_B_SOUL: 'R&B & Soul',
  REGGAE: 'Reggae',
  REGGAETON: 'Reggaeton',
  ROCK: 'Rock',
  SOUNDTRACK: 'Soundtrack',
  TECHNO: 'Techno',
  TRANCE: 'Trance',
  TRAP: 'Trap',
  TRIPHOP: 'Triphop',
  WORLD: 'World'
} as const
